import React, { useEffect } from 'react'
import { Stack } from 'expo-router'
import { useStore } from '@/router/(root)/pocketPick/pocketPickModule'

export default function PocketPickLayout() {
  
  const setPlayedDate = useStore((s) => s.setPlayedDate)

  useEffect(() => {
    setPlayedDate()
  }, [])

  return <Stack screenOptions={{ headerShown: false }} />
}
